// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"073f69b5","585":"c3c5c11f"}[chunkId] + ".css";
};